"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserAuthorizationType = void 0;
/**
 * 用户授权类型
 */
var UserAuthorizationType;
(function (UserAuthorizationType) {
    UserAuthorizationType[UserAuthorizationType["PHONE"] = 0] = "PHONE";
    UserAuthorizationType[UserAuthorizationType["EMAIL"] = 1] = "EMAIL";
    UserAuthorizationType[UserAuthorizationType["APPLE"] = 2] = "APPLE";
    UserAuthorizationType[UserAuthorizationType["WECHAT"] = 3] = "WECHAT";
    UserAuthorizationType[UserAuthorizationType["QQ"] = 4] = "QQ";
    UserAuthorizationType[UserAuthorizationType["PASSWORD"] = 5] = "PASSWORD";
})(UserAuthorizationType = exports.UserAuthorizationType || (exports.UserAuthorizationType = {}));
